import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
import IConfiguration from 'icons/IConfiguration';
import IWelcome from './IWelcome';
import IThirdParties from './IThirdParties';
import IProposals from './IProposals';
import IAssets from './IAssets';
import IScoring from './IScoring';
import IPurchaseOrder from './IPurchaseOrder';
import IContracts from './IContracts';
import ICalculator from './ICalculator';
import IQuickActions from './IQuickActions';
import IChecks from './IChecks';
import ITasks from './ITasks';
import ISettings from './ISettings';
import ILogout from './ILogout';
import IFilter from './IFilter';
import IGridAction from './IGridAction';
import IActions from './IActions';
import IRefesh from './IRefesh';
import IHide from './IHide';
import IClose from './IClose';
import ISearch from './ISearch';
import IPaymentschedule from './IPaymentschedule';
import IAdd from './IAdd';
import IDelete from './IDelete';
import IUpdate from './IUpdate';
import ISave from './ISave';
import ICloseTask from './ICloseTask';
import ICheckTask from './ICheckTask';
import INotification from './INotification';
import IAlert from './IAlert';
import IDownload from './IDownload';
import ICart from './ICart';
import ISearchFilter from './ISearchFilter';
import ICatalog from './ICatalog';
import IDashboard from './IDashboard';
import IPortfolio from './IPortfolio';
import IHelp from './IHelp';
import IProcess from './IProcess';
import IDatePicker from './IDatePicker';
import IUser from './IUser';
import IDataStorage from './IDataStorage';
import IFavorite from './IFavorite';
import IUnlock from './IUnlock';
import IMail from './IMail';
import IUplaod from './IUplaod';
import IDocument from './IDocument';

const UtinaIcon = (props: any) => {
  if (props.pagicon !== '') {
    switch (props.pagicon) {
      case 'ICONFIG':
        return <IConfiguration {...props} />;
      case 'IWELCOME':
        return <IWelcome {...props} />;
      case 'ITHIRDP':
        return <IThirdParties {...props} />;
      case 'IPROPOSAL':
        return <IProposals {...props} />;
      case 'IASSET':
        return <IAssets {...props} />;
      case 'ISCORING':
        return <IScoring {...props} />;
      case 'IPORDER':
        return <IPurchaseOrder {...props} />;
      case 'ICONTRACTS':
        return <IContracts {...props} />;
      case 'ICALCUL':
        return <ICalculator {...props} />;
      case 'IQACTION':
        return <IQuickActions {...props} />;
      case 'ICHECKS':
        return <IChecks {...props} />;
      case 'ITASKS':
        return <ITasks {...props} />;
      case 'ISETTING':
        return <ISettings {...props} />;
      case 'ILOGOUT':
        return <ILogout {...props} />;
      case 'IFILTER':
        return <IFilter {...props} />;
      case 'IGACTION':
        return <IGridAction {...props} />;
      case 'IACTION':
        return <IActions {...props} />;
      case 'IREFRESH':
        return <IRefesh {...props} />;
      case 'IHIDE':
        return <IHide {...props} />;
      case 'ICLOSE':
        return <IClose {...props} />;
      case 'ISEARCH':
        return <ISearch {...props} />;
      case 'IPAYSCHED':
        return <IPaymentschedule {...props} />;
      case 'ICONTRACT':
        return <IContracts {...props} />;
      case 'IADD':
        return <IAdd {...props} />;
      case 'IDELETE':
        return <IDelete {...props} />;
      case 'IUPDATE':
        return <IUpdate {...props} />;
      case 'ISAVE':
        return <ISave {...props} />;
      case 'ICLOSETSK':
        return <ICloseTask {...props} />;
      case 'ICHECKTSK':
        return <ICheckTask {...props} />;
      case 'IASSIGNT':
        return <IClose {...props} />;
      case 'INOTIF':
        return <INotification {...props} />;
      case 'IALERT':
        return <IAlert {...props} />;
      case 'IDOWNLOAD':
        return <IDownload {...props} />;
      case 'ICART':
        return <ICart {...props} />;
      case 'ISFILTER':
        return <ISearchFilter {...props} />;
      case 'ICATALOG':
        return <ICatalog {...props} />;
      case 'IDASHB':
        return <IDashboard {...props} />;
      case 'IPORTF':
        return <IPortfolio {...props} />;
      case 'IHELP':
        return <IHelp {...props} />;
      case 'IPROCESS':
        return <IProcess {...props} />;
      case 'IDATEPICK':
        return <IDatePicker {...props} />;
      case 'IUSER':
        return <IUser {...props} />;
      case 'IPROCESSB':
        return <IProcess {...props} />;
      case 'IDATASTOR':
        return <IDataStorage {...props} />;
      case 'IFAV':
        return <IFavorite {...props} />;
      case 'IUNLOCK':
        return <IUnlock {...props} />;
      case 'IMAIL':
        return <IMail {...props} />;
      case 'IUPLOAD':
        return <IUplaod {...props} />;
      case 'IDOCUMENT':
        return <IDocument {...props} />;

      default:
        return <Icon component={() => <span />}  {...props} />;
    }
  } else return <Icon component={() => <span />} {...props} />;
};

export default UtinaIcon;
